import { ForgotPasswordPage, PasswordResetPage } from "./pages/ForgotPasswordPage";
import { lazy, Suspense } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { AppShell } from "./components/AppShell";
import { useAuth } from "./lib/auth";
import { LoginPage } from "./pages/LoginPage";
import { FirstPasswordPage } from "./pages/FirstPasswordPage";
import { PublicCareersPage } from "./pages/PublicCareersPage";
import { CandidateTestPage } from "./pages/CandidateTestPage";
import { EmployeeSelfServicePage } from "./pages/EmployeeSelfServicePage";
import { PublicTrainingPage } from "./pages/PublicTrainingPage";
import { PublicSurveyPage } from "./pages/PublicSurveyPage";
import { PublicRequestsPage } from "./pages/PublicRequestsPage";

const DashboardPage = lazy(() => import("./pages/DashboardPage").then((module) => ({ default: module.DashboardPage })));
const DecisionDashboardPage = lazy(() => import("./pages/DecisionDashboardPage").then((module) => ({ default: module.DecisionDashboardPage })));
const PersonnelPage = lazy(() => import("./pages/PersonnelPage").then((module) => ({ default: module.PersonnelPage })));
const RecruitmentPage = lazy(() => import("./pages/RecruitmentPage").then((module) => ({ default: module.RecruitmentPage })));
const OnlineTestsPage = lazy(() => import("./pages/OnlineTestsPage").then((module) => ({ default: module.OnlineTestsPage })));
const LeavePage = lazy(() => import("./pages/LeavePage").then((module) => ({ default: module.LeavePage })));
const PayrollPage = lazy(() => import("./pages/PayrollPage").then((module) => ({ default: module.PayrollPage })));
const TrainingPage = lazy(() => import("./pages/TrainingPage").then((module) => ({ default: module.TrainingPage })));
const AnalyticsPage = lazy(() => import("./pages/AnalyticsPage").then((module) => ({ default: module.AnalyticsPage })));
const SettingsPage = lazy(() => import("./pages/SettingsPage").then((module) => ({ default: module.SettingsPage })));
const ProfilePage = lazy(() => import("./pages/ProfilePage").then((module) => ({ default: module.ProfilePage })));
const TasksPage = lazy(() => import("./pages/TasksPage").then((module) => ({ default: module.TasksPage })));
const AiAssistantPage = lazy(() => import("./pages/AiAssistantPage").then((module) => ({ default: module.AiAssistantPage })));
const RequestsPage = lazy(() => import("./pages/RequestsPage").then((module) => ({ default: module.RequestsPage })));

export function App() {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (location.pathname === "/mot-de-passe-oublie") return <ForgotPasswordPage />;
  if (location.pathname.startsWith("/reinitialiser-mot-de-passe/")) return <PasswordResetPage />;
  const publicPath = location.pathname.startsWith("/carriere")
    || location.pathname.startsWith("/test-candidat/")
    || location.pathname.startsWith("/completer-profil/")
    || location.pathname.startsWith("/formation-publique/")
    || location.pathname.startsWith("/enquete/")
    || location.pathname.startsWith("/demandes-employes/");
  if (publicPath) {
    return (
      <Routes>
        <Route path="/carriere/*" element={<PublicCareersPage />} />
        <Route path="/test-candidat/:token" element={<CandidateTestPage />} />
        <Route path="/completer-profil/:token" element={<EmployeeSelfServicePage />} />
        <Route path="/formation-publique/:token" element={<PublicTrainingPage />} />
        <Route path="/enquete/:token" element={<PublicSurveyPage />} />
        <Route path="/demandes-employes/:token" element={<PublicRequestsPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    );
  }
  if (loading) return <div className="auth-loading"><img src="/sanru-logo.jpg" alt="SANRU" /><span>Ouverture de l’espace sécurisé…</span></div>;
  if (!user) return <LoginPage />;
  if (user.mustChangePassword) return <FirstPasswordPage />;
  return (
    <AppShell>
      <Suspense fallback={<div className="route-loading" role="status">Chargement de l’espace RH…</div>}>
        <Routes>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/personnel" element={<PersonnelPage />} />
          <Route path="/pilotage" element={<DecisionDashboardPage />} />
          <Route path="/recrutement" element={<RecruitmentPage />} />
          <Route path="/tests-recrutement" element={<OnlineTestsPage />} />
          <Route path="/conges" element={<LeavePage />} />
          <Route path="/paie" element={<PayrollPage />} />
          <Route path="/formation" element={<TrainingPage />} />
          <Route path="/analytique" element={<AnalyticsPage />} />
          <Route path="/assistant-ia" element={<AiAssistantPage />} />
          <Route path="/parametres" element={<SettingsPage />} />
          <Route path="/profil" element={<ProfilePage />} />
          <Route path="/taches-rh" element={<TasksPage />} />
          <Route path="/demandes" element={<RequestsPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
    </AppShell>
  );
}
